var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tree-menu"
  }, [_c('STreeList', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "changeSelect": _vm.onSelect
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };